export default {
  'content-flow.none': 'Aucun horaire STEAMS disponible pour ce cours',
  'content-flow.loading': 'Chargér...',
  'content-flow.no.slides': "Il n'y a pas de diapositives pour cette leçon",
};
